import { createSelector } from 'reselect'
import { StepId, CaseSchema } from '@feedyou-ai/feedbot-schema'

import { dialogsSelector } from '../flow/selectors/dialogsSelector'

export const parentDialogIdForStepSelector = (stepId: StepId) =>
  createSelector(
    dialogsSelector, // I <3 PRETTIER
    dialogs => {
      for (const dialogId in dialogs) {
        const currentlyIteratedDialog = dialogs[dialogId]
        for (const step of currentlyIteratedDialog.steps) {
          if (step.id === stepId) return dialogId
        }
      }
    }
  )

export const parentDialogIdAndSwitchStepIdForSwitchCaseSelector = (caseId: StepId) =>
  createSelector(
    dialogsSelector, // I <3 PRETTIER
    dialogs => {
      for (const dialogId in dialogs) {
        const switchSteps = dialogs[dialogId].steps.filter(step => step.type === 'switch')
        for (const switchStep of switchSteps) {
          if (
            (switchStep?.default?.id || 'default') === caseId ||
            (switchStep?.cases || []).some((caseItem: CaseSchema) => caseItem.id === caseId)
          ) {
            return { stepId: switchStep.id, parentDialogId: dialogId }
          }
        }
      }
    }
  )
